import { InspirationPayload } from 'helpers/pubsub';

interface GoogleAnalyticsEventObj {
    name?: string;
    version?: string;
    event_category?: string;
    event_action?: string;
    event_label?: string;
    page_path?: string;
    page_location?: string;
    custom?: {
        [key: string]: any;
    };
    params?: {
        [key: string]: any;
    };
}

declare const window: Window & {
    sendEvent?: (eventObj: GoogleAnalyticsEventObj) => void;
};

export type InspirationGaEvent = InspirationPayload & {
    ga?: {
        custom?: any;
    };
};
export const logAddItemsToFavourites = (
    source: string,
    listId: string,
    items: Array<{
        itemNo: string;
        quantity: number;
        type: string;
    }>,
    ga?: {
        custom: any;
    }
) => {
    // Concatenate 'itemNos', 'types' and 'quantities' as strings. E.g.:
    // itemNos = 12345678,34567890
    // types = ART,SPR
    // quantities = 2,1
    const { itemNos, types, quantities } = items.reduce(
        (acc, curr) => ({
            itemNos: acc.itemNos ? `${acc.itemNos},${curr.itemNo}` : curr.itemNo,
            types: acc.types ? `${acc.types},${curr.type}` : curr.type,
            quantities: acc.quantities ? `${acc.quantities},${curr.quantity}` : String(curr.quantity),
        }),
        { itemNos: '', types: '', quantities: '' }
    );

    typeof window.sendEvent === 'function' &&
        window.sendEvent({
            event_category: 'ecommerce',
            event_action: 'add_to_wishlist',
            event_label: source,
            custom: {
                list_id: listId,
                item_number_event: itemNos,
                item_type_event: types,
                product_quantity: quantities,
                ...ga?.custom,
            },
        });
};

export const logRemoveItemFromFavourites = (
    source: string,
    listId: string,
    productNumber: string,
    productType: string,
    quantity: number,
    ga?: {
        custom: any;
    }
) =>
    typeof window.sendEvent === 'function' &&
    window.sendEvent({
        event_category: 'ecommerce',
        event_action: 'remove_from_wishlist',
        event_label: source,
        custom: {
            list_id: listId,
            item_number_event: productNumber,
            item_type_event: productType,
            product_quantity: quantity,
            ...ga?.custom,
        },
    });

export const logEvent = (category: string, action: string, label: string) =>
    typeof window.sendEvent === 'function' &&
    window.sendEvent({
        event_category: category,
        event_action: action,
        event_label: label,
    });

export const logAddInspiration = (event: InspirationGaEvent) => {
    const custom = {
        component_id: event.ids,
        ...event?.ga?.custom,
    };
    typeof window.sendEvent === 'function' &&
        window.sendEvent({
            event_category: 'inspiration',
            event_action: 'added_to_inspiration',
            event_label: event.source,
            custom,
        });
};

export const logShowInspirations = () => {
    typeof window.sendEvent === 'function' &&
        window.sendEvent({
            event_category: 'inspiration',
            event_action: 'click_to_inspiration_list',
            event_label: 'notification',
        });
};

export const logRemoveInspiration = (event: InspirationGaEvent) => {
    const custom = {
        component_id: event.ids,
        ...event?.ga?.custom,
    };
    typeof window.sendEvent === 'function' &&
        window.sendEvent({
            event_category: 'inspiration',
            event_action: 'removed_from_inspiration',
            event_label: event.source,
            custom,
        });
};
export enum BuyNowEventType {
    DISPLAY = 'buy_now_displayed',
    CLICK = 'buy_now_clicked',
    ERROR = 'buy_now_error',
}
